/**
 * App version constants
 * VITE_VERSION_NUMBER is injected during the CI pipeline (see Makefile) from the GitLab tag.
 * APP_VERSION is injected by Vite during the build process, used for both development and production builds.
 * If neither is set, it defaults to '1.0.0'
 */
export const APP_VERSION_NUMBER = import.meta.env.VITE_VERSION_NUMBER || __APP_VERSION__ || '1.0.0'
